export const dashboardModel: any = {
  totalItems: 0,
  drafts: 0,
  inReview: 0,
  approved: 0,
  published: 286000,
  withoutPrimaryPhoto: 100000000,
  withInvalidFitments: 40500000,
  withValidationErrors: 5902580,
  updatetIn30Days: 258,
  createdSince1Oct: 64,
};
